import {DataStatus} from 'platform/components';

import {isNull} from 'ramda-adjunct';

import {useCountByQueryId} from '../hooks/useCountByQueryId';
import {RowControl} from './RowControl';

export type RowControlWrapperProps = {
  onChange: (entityIndex: string, sourceSearchParams: string) => void;
};
export const RowControlWrapper = (props: RowControlWrapperProps) => {
  const {count, hasSourceParams} = useCountByQueryId();

  if (!hasSourceParams) {
    return null;
  }

  if (isNull(count)) {
    return <DataStatus isLoading></DataStatus>;
  }

  return <RowControl count={count} onChange={props.onChange} />;
};
